<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormCalendar fieldName="operation_date"
                                      label="Operation date"
                                      size="2"
                                      v-model:field="search.operation_date" />
                        <FormCalendar fieldName="accounting_date"
                                      label="Accounting date"
                                      size="2"
                                      v-model:field="search.accounting_date" />
                        <FormInputNumber fieldName="amount"
                                         label="Amount"
                                         size="4"
                                         v-model:field="search.amount" />
                        <FormInputText fieldName="currency"
                                       label="Currency"
                                       size="2"
                                       v-model:field="search.currency" />
                        <FormInputText fieldName="operation_type"
                                       label="Operation type"
                                       size="2"
                                       v-model:field="search.operation_type" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="transaction_number"
                                       label="Transaction number"
                                       size="3"
                                       v-model:field="search.transaction_number" />
                        <FormInputText fieldName="instruction_ident"
                                       label="Instruction identificator"
                                       size="3"
                                       v-model:field="search.instruction_ident" />
                        <FormInputText fieldName="transaction_ident"
                                       label="Transaction identificator"
                                       size="3"
                                       v-model:field="search.transaction_ident" />
                        <FormInputText fieldName="reference_ident"
                                       label="Reference identificator"
                                       size="3"
                                       v-model:field="search.reference_ident" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="company_bank_account"
                                       label="Company bank account"
                                       size="3"
                                       v-model:field="search.company_bank_account" />
                        <FormInputText fieldName="contractor_bank_account"
                                       label="Contractor bank account"
                                       size="3"
                                       v-model:field="search.contractor_bank_account" />
                        <FormInputText fieldName="contractor_name"
                                       label="Contractor name"
                                       size="6"
                                       v-model:field="search.contractor_name" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="transfer_title"
                                       label="Transfer title"
                                       size="6"
                                       v-model:field="search.transfer_title" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import { prepareSearch, yesNoOptions } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

prepareSearch(search, props)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
